export default function SpinnerDot({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" style={{ animation: 'spin 0.9s linear infinite', flexShrink: 0 }}>
      <circle cx="8" cy="8" r="6" fill="none" stroke="hsl(var(--border))" strokeWidth="1.8"/>
      <path d="M14 8a6 6 0 0 0-6-6" fill="none" stroke="hsl(var(--primary))" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
}
